import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';
import { replace } from 'connected-react-router';

import {
	LOADING,
	CHANGE_LOGIN_EMAIL,
	CHANGE_LOGIN_PASSWORD,
	LOGIN_SUCCESS,
	LOAD_USER_FROM_LOCAL_STORAGE,
	UPDATE_PROFILE_SUCCESS,
	CHANGE_PASSWORD_SUCCESS,
	LOGOUT_SUCCESS,
	USER_CAN_ACCESS_POS_SETTINGS,
	CLEAR_MESSAGE,
	USER_CAN_PAUSE_ALL_RESTAURANTS
} from '../types';
import MessageUtils from "../../utils/MessageUtils";

export const changeLoginEmail = (email) => {
	return {
		type: CHANGE_LOGIN_EMAIL,
		payload: email
	};
};

export const changeLoginPassword = (password) => {
	return {
		type: CHANGE_LOGIN_PASSWORD,
		payload: password
	};
};

export const login = (email, password) => {
	return (dispatch) => {

		dispatch({ type: LOADING, payload: true });

		const url = `/user/login`;

		const loginData = {
			email: email,
			password: password
		}

		axios().post(url, loginData)
			.then(response => loginSuccess(dispatch, response))
			.catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:userActions.invalidInputData')));
	};
};

const loginSuccess = (dispatch, response) => {
	dispatch({ type: LOADING, payload: false });
	dispatch({ type: LOGIN_SUCCESS, payload: response.data });

	const user = response.data.data[0];
	const token = response.data.token;
	saveUserToLocalStorage(user, token);

	dispatch(replace('/restaurants'));
};

export const forgotPassword = (email) => {
	return (dispatch) => {

		dispatch({ type: LOADING, payload: true });

		const url = `/user/forgot-password?email=${email}`;

		axios().get(url)
			.then(response => forgotPasswordSuccess(dispatch, response))
			.catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:userActions.invalidEmailInputData')));
	};
};

const forgotPasswordSuccess = (dispatch, response) => {
	dispatch({ type: LOADING, payload: false });

	MessageUtils.dispatchSuccessMessage(dispatch, response.data.userMessage);

	setTimeout(() => {
		dispatch({ type: CLEAR_MESSAGE });
		dispatch(replace('/'));
	}, 3000);

};

export const resetPassword = (state) => {
	return (dispatch) => {

		dispatch({ type: LOADING, payload: true });

		const url = `/user/reset-password`;

		const resetPasswordData = {
			email: state.email,
			password: state.newPassword,
			secretKey: state.secretKey + '='
		};

		axios().put(url, resetPasswordData)
			.then(response => resetPasswordSuccess(dispatch, response))
			.catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:userActions.resetPasswordFailure')));
	};
};

const resetPasswordSuccess = (dispatch, response) => {
	dispatch({ type: LOADING, payload: false });

	MessageUtils.dispatchSuccessMessage(dispatch, response.data.userMessage);

	setTimeout(() => {
		dispatch({ type: CLEAR_MESSAGE });
		dispatch(replace('/'));
	}, 3000);

};

const saveUserToLocalStorage = (user, token) => {
	if (token !== undefined && token !== null && token !== '') {
		localStorage.setItem('token', token);
	}
	localStorage.setItem('id', user.id);
	localStorage.setItem('name', user.name);
	localStorage.setItem('email', user.email);
	localStorage.setItem('phone', user.phone);
	localStorage.setItem('language', user.language);
	localStorage.setItem('role', user.role);
	localStorage.setItem('countryCode', user.countryCode);
};

export const loadUserFromLocalStorage = () => {
	return (dispatch) => {
		const user = {
			id: localStorage.getItem('id'),
			email: localStorage.getItem('email'),
			token: localStorage.getItem('token'),
			name: localStorage.getItem('name'),
			phone: localStorage.getItem('phone'),
			language: localStorage.getItem('language'),
			role: localStorage.getItem('role'),
			countryCode: localStorage.getItem('countryCode')
		};

		dispatch({ type: LOAD_USER_FROM_LOCAL_STORAGE, payload: user });
	};
};

export const updateUser = (changedUser) => {
	return (dispatch, getState) => {

		dispatch({ type: LOADING, payload: true });

		const currentUser = getState().user;
		const url = `/user/${currentUser.id}`;

		const user = {
			id: currentUser.id,
			name: changedUser.name,
			phone: changedUser.phone,
			email: changedUser.email,
			countryCode: changedUser.countryCode,
			language: changedUser.language,
			role: currentUser.role,
			active: true
		};

		axios().put(url, user)
			.then(response => updateUserSuccess(dispatch, response))
			.catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
	};
};

const updateUserSuccess = (dispatch, response) => {
	dispatch({ type: LOADING, payload: false });
	MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));

	dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: response.data });

	saveUserToLocalStorage(response.data);
};

export const changePassword = (oldPassword, newPassword) => {
	return (dispatch, getState) => {

		dispatch({ type: LOADING, payload: true });

		const currentUser = getState().user;
		const url = `/user/${currentUser.id}/changePassword`;

		const passwordData = {
			oldPassword: oldPassword,
			newPassword: newPassword
		};

		axios().post(url, passwordData)
			.then(response => changePasswordSuccess(dispatch, response))
			.catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
	};
};


const changePasswordSuccess = (dispatch, response) => {
	MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:userActions.savePassSuccess'));
	dispatch({ type: LOADING, payload: false });

	// TODO may be somehow use this to show a success message
	dispatch({ type: CHANGE_PASSWORD_SUCCESS });
};

export const logout = () => {

	return (dispatch) => {

		dispatch({ type: LOADING, payload: true });

		const url = `/user/logout`;

		axios().delete(url)
			.then(response => logoutSuccess(dispatch, response))
			.catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:userActions.logoutFailure')));
	};
};

const logoutSuccess = (dispatch) => {
	dispatch({ type: LOADING, payload: false });
	dispatch({ type: LOGOUT_SUCCESS });

	const language = localStorage.getItem('translationLanguage') ? localStorage.getItem('translationLanguage') : 'en';
	localStorage.clear();
	localStorage.setItem('translationLanguage', language);

	dispatch(replace('/'));
};


export const canUserAccessPosSettings = (userPassword) => {
	return (dispatch, getState) => {

		dispatch({ type: LOADING, payload: true });

		const url = `/user/validate`;

		const userEmail = getState().user.email;

		const loginRequest = {
			email: userEmail,
			password: userPassword
		}

		axios().post(url, loginRequest)
			.then(response => canUserAccessPosSettingsSuccess(dispatch, response))
			.catch(() => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:userActions.loginFailure')));
	};
}

const canUserAccessPosSettingsSuccess = (dispatch, response) => {
	dispatch({ type: LOADING, payload: false });
	dispatch({ type: USER_CAN_ACCESS_POS_SETTINGS, payload: response.data.data[0].valid });

	if (!response.data.data[0].valid) {
		MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:userActions.invalidPassword'));
	}
};


export const resetUserAccessToPos = () => {
	return (dispatch, getState) => {
		dispatch({ type: USER_CAN_ACCESS_POS_SETTINGS, payload: false });
	}
}

export const deleteUserProfile = (userId, callback) => {
	return (dispatch) => {

		dispatch({ type: LOADING, payload: true });

		const url = `/user/${userId}`;

		axios().delete(url)
			.then(response => deleteUserProfileSuccess(dispatch, callback))
			.catch(error => deleteUserProfileFailure(dispatch, error, callback));
	};
};

const deleteUserProfileSuccess = (dispatch, callback) => {
	dispatch({ type: LOADING, payload: false });

	if (callback) {
		callback();
	}

	localStorage.clear();
	dispatch(replace('/'));
	MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:userActions.deleteUserSuccess'));
};

const deleteUserProfileFailure = (dispatch, error, callback) => {
	dispatch({ type: LOADING, payload: false });

	if (callback) {
		callback();
	}

	MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:userActions.deleteUserProfileFailure'))
};

export const canUserAccessPauseAllRestaurants = (userCode, callback) => {
	return (dispatch) => {
		dispatch({ type: LOADING, payload: true });
		const url = `/user/verify-pause-all-restaurants-code`;

		const verificationCode = {
			verificationCode: userCode
		}

		axios().post(url, verificationCode)
			.then(response => {
				dispatch({ type: LOADING, payload: false });
				dispatch({ type: USER_CAN_PAUSE_ALL_RESTAURANTS, payload: true });
				if (callback) {
					callback();
				}
			})
			.catch(() => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:userActions.invalidCode')));
	};
}

export const resetUserAccessPauseAllRestaurants = () => {
	return (dispatch) => {
		dispatch({ type: USER_CAN_PAUSE_ALL_RESTAURANTS, payload: false })
	}
}


// WEBPACK FOOTER //
// ./src/actions/users/UserActions.js